import { jsx } from 'react/jsx-runtime';
import { ContextMenu } from '@fabric-app/ui/components/ContextMenu/ContextMenu';
import { useResourceDataContextSafe } from '../../../../resource-detail/components/context/resourceDataContext.js';
import { useResponsive } from '@fabric-app/ui/hooks/useResponsive';
import { useMemo } from 'react';
import LabelSelector from '../../../../labels/components/LabelSelector/LabelSelector.js';

const ContextItemColorLabels = ({ colorLabels, rootId }) => {
  const { isMobileView } = useResponsive();
  const { resource, disabledActions } = useResourceDataContextSafe();
  const resources = useMemo(() => [
    {
      id: resource.id,
      label: resource.label
    }
  ], [
    resource
  ]);
  return colorLabels && colorLabels.length > 0 && rootId && !isMobileView && !disabledActions.modifyLabel ? /* @__PURE__ */ jsx(ContextMenu.ItemRaw, {
    children: /* @__PURE__ */ jsx(LabelSelector, {
      spaceId: rootId,
      resources,
      colorLabels
    })
  }) : null;
};

export { ContextItemColorLabels };
//# sourceMappingURL=ContextItemLabels.js.map
